<template>
	<div class="flex items-center">
		<slot />

		<span class="inline-block w-0 overflow-visible">
			<Badge
				:variant="badgeVariant"
				:aria-hidden="!showTooltip"
				class="w-fit translate-x-2 whitespace-nowrap text-xs font-medium transition-opacity duration-300 ease-in-out"
				:class="showTooltip ? 'opacity-100' : 'opacity-0 pointer-events-none'"
			>
				{{ tooltipText }}
			</Badge>
		</span>
	</div>
</template>

<script setup lang="ts">
import type { TooltipButtonProps } from '.';

import Badge from '../badge/Badge.vue';

withDefaults(defineProps<TooltipButtonProps>(), {
	badgeVariant: 'primary',
	showTooltip: false
});
</script>
